import { TOGGLE_FILTER_ABROAD } from 'app/actions/filter/actions';
import Immutable from 'immutable';

const FILTER = 'filter';
const FILTER_ABROAD = 'abroad';

const initialState = Immutable.fromJS({
    abroad: null,
});

export default function filter(state = initialState, action = '') {
    switch (action.type) {
        case TOGGLE_FILTER_ABROAD:
            return state.setIn([FILTER_ABROAD], action.payload);
        default:
            return state;
    }
}

export const filterAbroadSelector = (state) => state.getIn([FILTER, FILTER_ABROAD]);
